<ng-container *transloco="let t">
<header class="host ___dashboard">

  <div class="toggler">
    <button class="icon-medium-tint icon-dashboard-menu" (click)="navService.toggleMenu()"></button>
  </div>

  <ul class="vendor dropmenu">
    <li>
      <a href="#" (click)="false"><i class="icon-medium-tint icon-dashboard-mola"></i></a>
      <ul class="submenu" aria-label="submenu">
        <li><a [usefulRouterLink]="['app-dashboard', 'about']">About Dashboard</a></li>
        <li><a href="https://mola.lamnhan.com" target="_blank">Mola Home</a></li>
        <li><a href="https://mola.lamnhan.com/docs" target="_blank">Documentation</a></li>
        <li><a href="mailto:mola@lamnhan.com">Support</a></li>
        <li><a href="mailto:mola@lamnhan.com">Feedback</a></li>
      </ul>
    </li>
  </ul>

  <ul class="app dropmenu">
    <li>
      <a href="#" (click)="false">
        <i class="icon-medium-tint icon-dashboard-home"></i><span>My App</span>
      </a>
      <ul class="submenu" aria-label="submenu">
        <li><a href="#" (click)="exitDashboard(); false">Visit App</a></li>
      </ul>
    </li>
  </ul>

  <nav class="nav">

    <div class="secondary" [class.visible]="navService.menuVisible">
      <div class="container">

        <ul class="body menu">

          <li [class]="menuItem.name" *ngFor="let menuItem of menuItems">
            <a
              (click)="navService.toggleMenu()"
              [usefulRouterLink]="menuItem.routerLink"
              usefulRouterLinkActive="active"
              [usefulRouterLinkActiveOptions]="{exact: true, also: menuItem.activeAlso || []}"
              [usefulRouterBackwardable]="false"
            >
              <i class="icon-medium-tint" [class]="menuItem.icon"></i>
              <span>{{ t(menuItem.text || '') || menuItem.text }}</span>
            </a>
            <ul class="submenu">
              <li *ngFor="let subItem of menuItem.subItems">
                <a
                  (click)="navService.toggleMenu()"
                  [usefulRouterLink]="subItem.routerLink"
                  usefulRouterLinkActive="active"
                  [usefulRouterLinkActiveOptions]="{exact: true}"
                  [usefulRouterBackwardable]="false"
                >{{ t(subItem.text || '') || subItem.text }}</a>
              </li>
            </ul>
          </li>

        </ul>

      </div>

      <div class="backdrop" (click)="navService.toggleMenu()"></div>
    </div>

  </nav>

  <ul class="account dropmenu" *ngIf="userService.currentUser">
    <li>
      <a href="#" (click)="false">
        <span>Howdy, {{ userService.data?.displayName || 'User' }}</span>
        <img [src]="userService.data?.photoURL || 'https://www.gravatar.com/avatar/none?d=mp'"/>
      </a>
      <ul class="submenu" aria-label="submenu">
        <li>
          <a
            [usefulRouterLink]="[userService.data?.username || 'account']"
          >{{ userService.data?.displayName || 'User' }}</a>
        </li>
        <li><a [usefulRouterLink]="['account']">My Account</a></li>
        <li><a href="#" (click)="exitDashboard(); false">Exit Dashboard</a></li>
        <li><a href="#" (click)="logOut(); false">Sign Out</a></li>
      </ul>
    </li>
  </ul>
  
</header>
</ng-container>